import { useStudentStore } from '@js/stores/student/student';

export default {
  created() {
    window.addEventListener('pageshow', this.handleShortlistPageRestore);
  },
  beforeDestroy() {
    window.removeEventListener('pageshow', this.handleShortlistPageRestore);
  },
  methods: {
    async handleShortlistPageRestore(event) {
      if (!event.persisted) return;

      try {
        const store = useStudentStore();
        const shortlist = await store.refreshShortlist();
        this.onShortlistRestored(shortlist);

        document.querySelectorAll('span[data-shortlist]').forEach((icon) => {
          icon.setAttribute('data-shortlist', store.shortlistedPropertiesCount);
          icon.classList.toggle(
            'nineplus',
            store.shortlistedPropertiesCount > 9
          );
        });
      } catch (error) {
        console.error(
          'Could not refresh shortlist after back navigation',
          error
        );
      }
    },
  },
};
